import { BaseDataDefinition } from "./BaseDataDefinition";
import { DataTypes } from "../DataTypes";
import { ValidationIssue } from "../../IDesignValidationProvider";
import type { AppGlueAny } from "../../AppGlueAny";

export class BooleanDataDefinition extends BaseDataDefinition<boolean> {
    readonly type: DataTypes = DataTypes.BOOLEAN;

    static fromJSONObjectValue(value: AppGlueAny, name: string): BooleanDataDefinition | undefined {
        if (Array.isArray(value)) {
            if (!value.find((v) => typeof v !== "boolean")) {
                let def = new BooleanDataDefinition(name);
                def.list = true;

                return def;
            }
        } else if (typeof value === "boolean") {
            let def = new BooleanDataDefinition(name);
            return def;
        }

        return undefined;
    }

    static fromJSONSchema(obj: object, name?: string): BooleanDataDefinition | undefined {
        let def = new BooleanDataDefinition(name);

        let type = Reflect.get(obj, "type");
        if (type === "array") {
            def.list = true;
            let items = Reflect.get(obj, "items");

            type = Reflect.get(items, "type");

            if (type === "boolean") {
                return def;
            }
        } else if (type === "boolean") {
            return def;
        }

        return undefined;
    }

    verifyValueType(value: AppGlueAny): ValidationIssue | undefined {
        if (value === undefined) return new ValidationIssue("Undefined Value");

        if (this.list) {
            // check is array
            if (!Array.isArray(value)) return new ValidationIssue(value + " is not a boolean array");

            // check each value is of right type
            for (let n of value) {
                if (typeof n !== "boolean")
                    return new ValidationIssue(value + " has array members that are not boolean");
            }
        } else {
            if (Array.isArray(value)) return new ValidationIssue(value + " is a number array");

            if (typeof value !== "boolean") return new ValidationIssue(value + " is not a boolean");
        }

        return undefined;
    }

    convert(value: AppGlueAny): AppGlueAny {
        if (value === undefined) return undefined;

        if (this.list) {
            if (Array.isArray(value)) {
                let output: any[] = [];

                for (let n of value) {
                    output.push(this.convertValueToBoolean(n));
                }

                return output;
            }
            return value;
        } else {
            return this.convertValueToBoolean(value);
        }
    }

    convertValueToBoolean(value: AppGlueAny): AppGlueAny {
        if (value === undefined || value === null) return false;

        if (typeof value === "boolean") return value as boolean;

        // do some strings

        let stringVal = value.toString().toLowerCase();
        if (stringVal === "true") return true;

        if (stringVal === "false") return false;

        if (stringVal === "t") return true;

        if (stringVal === "f") return false;

        if (stringVal === "yes") return true;

        if (stringVal === "no") return false;

        return value;
    }

    toJSONObject(value: AppGlueAny): AppGlueAny {
        let issue = this.verifyValueType(this.convert(value));

        if (issue) {
            value = true;

            if (this.list) {
                value = [value];
            }
        }

        return this.convert(value);
    }
}
